<template>
  <section class="search-index">
    <ais-instant-search
      :search-client="searchClient"
      :index-name="index"
      :routing="routing"
      :class-names="{
        'ais-InstantSearch': 'search-index__wrapper',
      }"
    >
      <Breadcrumbs :searchQuery="currentSearchQuery" :viewStyle="viewStyle" />
      <Refinements
        class="search-index__filters"
        :facets="facets"
        :customFacet="customFacet"
      />
      <ais-infinite-hits
        :class-names="{
          'ais-InfiniteHits': 'search-index__results',
          'ais-InfiniteHits-list': 'search-index__results-list',
          'ais-InfiniteHits-item': getViewStyle(),
          'ais-InfiniteHits-loadMore': 'search-index__load-more-btn',
        }"
      >
        <div
          slot-scope="{ items, refineNext }"
          class="search-index__results-list"
        >
          <Context :viewStyle="viewStyle" />
          <p v-if="!items.length" class="search-index__no-results">
            No Results Found {{ handleResults(items.length) }}
          </p>
          <span v-else class="search-index__results-found">{{
            handleResults(items.length)
          }}</span>
          <Result
            v-for="item in items"
            :key="item.id"
            :tileType="tileType"
            :item="item"
            :viewStyle="viewStyle"
            :class="getViewStyle()"
          />
          <button
            :class="`search-index__load-more-btn-${index}`"
            style="visibility: hidden;"
            @click="refineNext"
          ></button>
        </div>
      </ais-infinite-hits>
      <ais-search-box
        :value="currentSearchQuery"
        :class-names="{
          'ais-SearchBox': 'search-index__form',
        }"
      />
      <ais-configure
        v-if="customFacet"
        :filters="`${customFacet.type}:${JSON.stringify(customFacet.value)}`"
      />
    </ais-instant-search>
    <button
      v-show="bottom"
      @click="scrollToTop()"
      class="search-index__to-top-btn"
    >
      <span class="material-icons">arrow_upward</span>
      Top
    </button>
  </section>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
// eslint-disable-next-line
import { history as historyRouter } from 'instantsearch.js/es/lib/routers'
import Breadcrumbs from '@/components/search/search-components/Breadcrumbs.vue'
import Result from '@/components/search/search-components/Result.vue'
import Refinements from '@/components/search/search-components/Refinements.vue'
import Context from '@/components/search/search-components/Context.vue'

export default {
  name: 'SearchResults',
  components: {
    Breadcrumbs,
    Result,
    Refinements,
    Context,
  },
  data() {
    return {
      bottom: false,
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_ID,
        process.env.VUE_APP_ALGOLIA_APP_KEY
      ),
      routing: {
        router: historyRouter(),
        stateMapping: {
          stateToRoute(uiState) {
            return {
              query: uiState.query,
              learningArea:
                uiState.refinementList &&
                uiState.refinementList['all_categories.name'] &&
                uiState.refinementList['all_categories.name'].join('~'),
              category:
                uiState.refinementList &&
                uiState.refinementList['categories.name'] &&
                uiState.refinementList['categories.name'].join('~'),
              vendor:
                uiState.refinementList &&
                uiState.refinementList.vendor &&
                uiState.refinementList.vendor.join('~'),
              instructor:
                uiState.refinementList &&
                uiState.refinementList.instructor &&
                uiState.refinementList.instructor.join('~'),
              difficulty:
                uiState.refinementList &&
                uiState.refinementList['difficulties.title'] &&
                uiState.refinementList['difficulties.title'].join('~'),
              headInstructor:
                uiState.refinementList &&
                uiState.refinementList['head_instructor.full_name'] &&
                uiState.refinementList['head_instructor.full_name'].join('~'),
              features:
                uiState.refinementList &&
                uiState.refinementList.features &&
                uiState.refinementList.features.join('~'),
            }
          },
          routeToState(routeToState) {
            return {
              query: routeToState.query,
              refinementList: {
                'all_categories.name':
                  routeToState.learningArea &&
                  routeToState.learningArea.split('~'),
                'categories.name':
                  routeToState.category && routeToState.category.split('~'),
                vendor: routeToState.vendor && routeToState.vendor.split('~'),
                instructor:
                  routeToState.instructor && routeToState.instructor.split('~'),
                'difficulties.title':
                  routeToState.difficulty && routeToState.difficulty.split('~'),
                'instructors.full_name':
                  routeToState.headInstructor &&
                  routeToState.headInstructor.split('~'),
                features:
                  routeToState.features && routeToState.features.split('~'),
              },
            }
          },
        },
      },
    }
  },
  props: {
    index: {
      type: String,
      required: true,
    },
    facets: {
      type: Array,
      required: true,
    },
    tileType: {
      type: String,
      required: true,
    },
    viewStyle: {
      type: String,
      required: true,
    },
    currentSearchQuery: {
      type: String,
      required: false,
    },
    customFacet: {
      type: Object,
      required: false,
    },
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.loadMore()
      }
    },
  },
  methods: {
    bottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight - 1000
      return bottomOfPage || pageHeight < visible
    },
    loadMore() {
      const loadMore = document.querySelector(
        `.search-index__load-more-btn-${this.index}`
      )
      if (loadMore) {
        loadMore.click()
      }
    },
    scrollToTop() {
      this.$scrollTo('.search-index', 500, {
        container: 'body',
        offset: -220,
      })
    },
    handleResults(length) {
      switch (this.index) {
        case 'courses':
          this.$store.dispatch('search/setCoursesResultCount', length)
          break
        case 'staging_courses':
          this.$store.dispatch('search/setCoursesResultCount', length)
          break
        case 'playlists':
          this.$store.dispatch('search/setPlaylistsResultCount', length)
          break
        case 'videos':
          this.$store.dispatch('search/setVideosResultCount', length)
          break
        default:
      }
    },
    getViewStyle() {
      switch (this.viewStyle) {
        case 'tile':
          if (this.index === 'videos') {
            return 'search-index__results-list-view'
          }
          return 'search-index__results-item'
        case 'list':
          return 'search-index__results-list-view'
        default:
          return 'search-index__results-item'
      }
    },
    isMobile() {
      if (window.innerWidth < 768) {
        this.$store.dispatch('search/setViewStyle', 'list')
      }
    },
  },
  created() {
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible()
    })
    this.isMobile()
  },
}
</script>

<style lang="scss">
.search-index {
  position: relative;
  padding: 20px 0 50px 0;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  &__filters {
    width: 100%;
    @include tablet {
      width: 35%;
    }
    @include desktop {
      width: 25%;
    }
  }
  &__results {
    width: 100%;
    @include tablet {
      width: 65%;
    }
    @include desktop {
      width: 75%;
    }
  }
  &__results-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    align-items: center;
    padding: 0;
    margin: 0;
  }
  &__results-item {
    width: 100%;
    margin: 0 0 10px 0;
    padding: 5px;
    background-color: var(--light-gray);
    height: 300px;
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: 33.3333%;
    }
    @include lg-desktop {
      width: 25%;
    }
  }
  &__results-list-view {
    display: flex;
    align-items: center;
    min-width: 100%;
    min-height: 80px;
    padding: 0 5px;
    margin: 5px 0 0 0;
    @include mobile {
      margin: 0 0 10px 0;
      padding: 15px 0 5px 15px;
    }
    &:nth-of-type(even) {
      background-color: var(--light-gray);
    }
  }
  &__load-more-btn {
    visibility: hidden;
  }
  &__form {
    visibility: hidden;
  }
  &__no-results {
    width: 100%;
    color: var(--white);
    font-size: 1.5rem;
    text-align: center;
    margin: 0 auto;
    text-transform: uppercase;
  }
  &__results-found {
    display: none;
  }
  &__to-top-btn {
    background: transparent;
    border: none;
    color: var(--white);
    font-size: 1rem;
    margin: 0 auto;
    transition: 0.5s all ease;
    position: absolute;
    bottom: 15px;
    left: 45%;
    @include desktop {
      left: 55%;
    }
    &:hover {
      cursor: pointer;
      color: var(--orange);
    }
  }
}
</style>
